import { CallToAction } from 'components/CallToAction'
import { GatsbyImage, getImage, withArtDirection, ImageDataLike, StaticImage } from 'gatsby-plugin-image'
import Link from 'components/Link'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import React from 'react'
import { heading, section } from './classes'
import Icon from './Icon'

const Chip = ({ icon, title, className,style }) => {
    // const Icon = NotProductIcons[icon] || ProductIcons[icon]
    return (
        <div className={`bg-gray-accent-light flex space-x-2 py-2 px-4 rounded-lg items-center mt-2 ${className}`}>
             {/* {Icon && <Icon className={`w-4 h-4 ${style}`} />} */}
            <Icon className="w-4 h-4" name={icon} />
            <span className="text-sm sm:text-[16px] font-bold">{title}</span>
        </div>
    )
}

const PipelineGraphic = ({description,icons}) => {
    return (
        <div className="hidden sm:grid grid-cols-1 lg:grid-cols-3 mt-16 col-span-3 w-1/4 lg:w-auto">
            <div className="flex justify-center items-center lg:flex-col">
                <Icon className="h-5 w-5" name="bullet" />
                <div className="lg:w-[1px] w-full lg:h-28 h-[1px] relative  border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
                <div className="h-1/2 lg:w-1/2  w-[1px] lg:h-[1px] self-end border-t-2 lg:border-l-2 border-gray-accent-light border-dashed " />
            </div>
            <div className="flex justify-center items-center lg:flex-col">
                <Icon className="h-5 w-5" name="bullet" />
                <div className="lg:w-[1px] w-full lg:h-28 h-[1px] relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
                <div className="lg:w-full w-[1px] lg:h-[1px] h-full self-end border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
            </div>
            <div className="flex justify-center items-center lg:flex-col">
                <Icon className="h-5 w-5" name="bullet" />
                <div className="w-full lg:w-[1px] h-1[px] lg:h-28 relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
                <div className="w-[1px] lg:w-1/2 h-full lg:h-[1px] self-start border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
            </div>
            <div className="flex justify-center items-center lg:flex-col relative lg:col-span-3">
                <div className="absolute left-0 lg:left-1/2 lg:-translate-x-1/2 w-full -top-8 z-10">
                    <Icon name="logo-bullet" className="w-16 h-16 mx-auto" />
                    <h5 className="text-lg font-bold hidden bg-tan border border-gray/50 px-4 py-2 lg:inline-flex rounded-full border-solid leading-none">
                        prebuilt analytics for 90% of your business questions
                    </h5>
                </div>

                <div className="w-full lg:w-[1px] h-[1px] lg:h-28 relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
                <div className="block lg:hidden w-[1px] lg:w-1/2 h-1/2 lg:h-[1px] self-start border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
                <Icon className="h-5 w-5 order-first lg:order-last" name="bullet" />
            </div>
        </div>
    )
}
const PipelineGraphic2 = ({description,icons}) => {
    return (
        <div className="hidden sm:grid grid-cols-1 lg:grid-cols-3 mt-16 cc w-1/4 lg:w-auto">
        {icons?.length > 0 && icons.map((icon, index) => {
            const { name, style='', parentStyle='' } = icon
            return (
                <>
        <div key={index} className={`flex justify-center items-center lg:flex-col ${parentStyle}`}>
        <Icon key={index}  className={style} name={name} />
        {(index==0) &&
        <>
        <div key={index} className="lg:w-[1px] w-full lg:h-28 h-[1px] relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
        <div key={index} className="h-1/2 lg:w-1/2  w-[1px] lg:h-[1px] border-l-2 lg:border-t-2 self-end border-gray-accent-light border-dashed" />
        </>}
        {(index==1) &&
        <>
        <div key={index} className="lg:w-[1px] w-full lg:h-28 h-[1px] relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
        <div key={index} className="lg:w-full w-[1px] lg:h-[1px] h-full lg:border-t-2 border-l-2 self-end lg:self-start border-gray-accent-light border-dashed" />
        </>}
        {(index==2) &&
        <>
        <div key={index} className="w-full lg:w-[1px] h-1[px] lg:h-28 relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
        <div key={index} className="w-[1px] lg:w-1/2 h-full lg:h-[1px] border-l-2 lg:border-t-2 self-start border-gray-accent-light border-dashed" />
        </>}
        {(index==3) &&
        <>
         <div className="absolute left-0 lg:left-1/2 lg:-translate-x-1/2 w-full -top-8 z-10">
        <h5 className="text-lg font-bold hidden bg-tan border border-gray/50 px-4 py-2 lg:inline-flex rounded-full border-solid leading-none">
        {description}
        </h5>
        </div>
        <div key={index} className="w-full lg:w-[1px] h-[1px] lg:h-28 relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
        <div key={index} className="block lg:hidden w-[1px] lg:w-1/2 h-1/2 lg:h-[1px] border-l-2 lg:border-t-2 self-start border-gray-accent-light border-dashed" />
        <Icon className="h-5 w-5 order-first lg:order-last" name="bullet" />
        </>}
    </div>
    </>
    ) })}

</div>
    )
}

    export default function Pipelines({ allPipelines, googleImages })  {
        const { img , style='',sections, pipelinesTitle,enable } = allPipelines
           if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
        const { title,  description, subtitle, icons } = pipelinesTitle
        let cta = allPipelines?.cta
        if (Array.isArray(cta) && cta.length == 1) cta = cta[0]
        const googleImage =
            img &&
            googleImages &&
            googleImages[0] &&
            googleImages[0].filter((image) => {
                if (image.name == img) return image
            })[0]
        const googleImage2 =
            img &&
            googleImages &&
            googleImages[1] &&
            googleImages[1].filter((image) => {
                if (image.name == img) return image
            })[0]
        const gatsbyImage = googleImage && getImage(googleImage)
        const gatsbyImage2 = googleImage2 && getImage(googleImage2)
    const breakpoints = useBreakpoint()

    return (
        <section className={section('text-center')}>
            <h2 className={heading()}>{title}</h2>
            <h3 className={heading('sm')}>
                {subtitle}
            </h3>
            <div className="lg:block flex">
            <div className="grid lg:grid-cols-3 mt-8 lg:mt-16 mb-8 gap-8 lg:gap-0 w-full sm:w-3/4 lg:w-auto">
            {sections?.length > 0 && sections.map((section, index) => {
                        const { name,  description, chips, style='' } = section
                        return (
                            <>
                    {(index==3) && !breakpoints.md && <PipelineGraphic description={description} icons={icons}/>}
                        <div key={index} className={style}>
                        <h4 key={index} className="text-2xl m-0 text-blue">{name}</h4>
                        <p key={index} className="text-lg font-semibold"
                                                    dangerouslySetInnerHTML={{ __html: description }}>
                        </p>
                        <div key={index} className="flex space-x-2 justify-center items-center flex-wrap max-w-xs mx-auto">
                        {chips?.length > 0 && chips.map((chip, index2) => {
                            const { title,  icon } = chip
                            return (

                            <Chip key={index2} icon={icon} title={title} />
                                 ) })}
                        </div>
                    </div>
                    </>
                    )
                })}
                </div>
                {breakpoints.md && <PipelineGraphic description={description} icons={icons}/>}
            </div>
        </section>
    )
}
// const PipelineGraphic = () => {
//     return (
//         <div className="hidden sm:grid grid-cols-1 lg:grid-cols-3 mt-16 col-span-3 w-1/4 lg:w-auto">
//             <div className="flex justify-center items-center lg:flex-col">
//                 <Icon className="h-5 w-5" name="bullet" />
//                 <div className="lg:w-[1px] w-full lg:h-28 h-[1px] relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
//                 <div className="h-1/2 lg:w-1/2  w-[1px] lg:h-[1px] border-l-2 lg:border-t-2 self-end border-gray-accent-light border-dashed" />
//             </div>
//             <div className="flex justify-center items-center lg:flex-col">
//                 <Icon className="h-5 w-5" name="bullet" />
//                 <div className="lg:w-[1px] w-full lg:h-28 h-[1px] relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
//                 <div className="lg:w-full w-[1px] lg:h-[1px] h-full lg:border-t-2 border-l-2 self-end lg:self-start border-gray-accent-light border-dashed" />
//             </div>
//             <div className="flex justify-center items-center lg:flex-col">
//                 <Icon className="h-5 w-5" name="bullet" />
//                 <div className="w-full lg:w-[1px] h-1[px] lg:h-28 relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
//                 <div className="w-[1px] lg:w-1/2 h-full lg:h-[1px] border-l-2 lg:border-t-2 self-start border-gray-accent-light border-dashed" />
//             </div>
//             <div className="flex justify-center items-center lg:flex-col relative lg:col-span-3">
//                 <div className="absolute left-0 lg:left-1/2 lg:-translate-x-1/2 w-full -top-8 z-10">
//                     <Icon name="logo-bullet" className="w-24 h-16 mx-auto" />
//                     <h5 className="text-lg font-bold hidden bg-tan border border-gray/50 px-4 py-2 lg:inline-flex rounded-full border-solid leading-none">
//                         Self-serve property management for 90% of your product questions
//                     </h5>
//                 </div>

//                 <div className="w-full lg:w-[1px] h-[1px] lg:h-28 relative border-t-2 lg:border-l-2 border-gray-accent-light border-dashed" />
//                 <div className="block lg:hidden w-[1px] lg:w-1/2 h-1/2 lg:h-[1px] border-l-2 lg:border-t-2 self-start border-gray-accent-light border-dashed" />
//                 <Icon className="h-5 w-5 order-first lg:order-last" name="bullet" />
//             </div>
//         </div>
//     )
// }
